import { render } from "./WinrateDisplay.vue?vue&type=template&id=7073bc78&ts=true"
import script from "./WinrateDisplay.vue?vue&type=script&lang=ts"
export * from "./WinrateDisplay.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__